import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgxPermissionsService } from "ngx-permissions";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { NavigationService } from "src/@vex/services/navigation.service";
import { environment } from "src/environments/environment";
import { CookieHandler } from "src/shared/classes/cookie.class";

@Injectable()
export class AuthService {
  private _menu = new BehaviorSubject<any[]>([]);
  menu$ = this._menu.asObservable();
  constructor(private readonly _http: HttpClient, private _ngxPermissionsService: NgxPermissionsService,
    private router: Router, private navigationService: NavigationService ,
    private permissionsService: NgxPermissionsService
  ) {}
  private readonly _baseUrl : string = `${environment.apiUrl}SMSAPI/`
  private readonly _baseUrl1 : string = `${environment.apiUrl}UserAPI/`

SinginAdmin(): Observable<any> {
  return this._http.get<any>(this._baseUrl1 + 'SinginAdmin').pipe(
    tap((res: any) => {
      const tokenData = res.response.token;
      localStorage.setItem('token', tokenData.token);
      localStorage.setItem('currentUser', JSON.stringify(tokenData));

      localStorage.setItem('menu', JSON.stringify(tokenData.menu));

      this._menu.next(tokenData.menu);
      const permissions: string[] = [];

const extractAccess = (items: any[]) => {
  items?.forEach(item => {

    if (item.access?.length) {
      permissions.push(...item.access);
    }

    if (item.children?.length) {
      extractAccess(item.children);
    }
  });
};

const menu = res.response.token.menu;

extractAccess(menu.dropDownMenu);
extractAccess(menu.linkMenu);

this._ngxPermissionsService.loadPermissions(permissions);

localStorage.setItem('permissions', JSON.stringify(permissions));
  const extractPrefixes = (menuItems: any[]): string[] => {
  const prefixes = new Set<string>();

  const traverse = (items: any[]) => {
    items.forEach(item => {
      item.access?.forEach((access: string) => {
        const parts = access.split(':');
        if (parts.length >= 2) {
          prefixes.add(parts[0] + ':' + parts[1]); // فقط دو بخش اول
        }
      });

      if (item.children?.length) {
        traverse(item.children);
      }
    });
  };

  traverse(menuItems);

  return Array.from(prefixes);
};

const allMenuItems = [...menu.dropDownMenu, ...menu.linkMenu];

const prefixes = extractPrefixes(allMenuItems);  

})
  );
}
public extractPermissions(menu: any): string[] {

  const permissions: string[] = [];

  const collect = (items: any[]) => {
    items.forEach(item => {

      if (item.access?.length) {
        permissions.push(...item.access);
      }

      if (item.children?.length) {
        collect(item.children);
      }
    });
  };

  collect(menu.dropDownMenu || []);
  collect(menu.linkMenu || []);

  return permissions;
}
initializeApp() {

  const storedMenu = localStorage.getItem('menu');

  if (storedMenu) {

    const menuData = JSON.parse(storedMenu);

    this._menu.next(menuData);

    const permissions = this.extractPermissions(menuData);
    this.permissionsService.loadPermissions(permissions);
  }
}

  
    loadMenuFromStorage() {
      const menu = localStorage.getItem('menu');
      if (menu) {
        this._menu.next(JSON.parse(menu));
      }
    }
  
  SendCodeAdmin(Id:number): Observable<any>  {
    return this._http.get(this._baseUrl+'SendCodeAdmin/'+Id);
    }
    logout(): void {
      CookieHandler.removeToken();
      localStorage.clear();
      this.setMenu([]);  
      this.navigationService.items = []; 
      this.router.navigate(['/login']);
    }
      
 public setMenu(menuSubMenus: any[]) {
  this._menu.next(menuSubMenus); // BehaviorSubject emit می‌کند
}

public buildNavigation(menuData: any): any[] {

  if (!menuData) return [];

  const combined = [
    ...(menuData.dropDownMenu || []),
    ...(menuData.linkMenu || [])
  ];

  const mergedMap = new Map<string, any>();

  combined.forEach(section => {

    if (!mergedMap.has(section.label.trim())) {
      mergedMap.set(section.label.trim(), {
        type: 'subheading',
        label: section.label.trim(),
        children: []
      });
    }

    const existing = mergedMap.get(section.label.trim());

    if (section.children?.length) {
      existing.children.push(...section.children);
    }
  });

  // تبدیل نهایی به فرمت vex
  return Array.from(mergedMap.values()).map(section => ({
    ...section,
    children: this.mapChildren(section.children)
  }));
}
private mapChildren(children: any[]): any[] {

  return children
    .filter(item => this.hasPermission(item))
    .map(item => {

      if (item.type === 'dropdown') {
        return {
          type: 'dropdown',
          label: item.label,
          icon: item.icon || 'mat:circle',
          children: this.mapChildren(item.children || [])
        };
      }

      return {
        type: 'link',
        label: item.label,
        route: item.route,
        icon: item.icon || 'mat:circle'
      };
    });
}
private hasPermission(item: any): boolean {

  if (!item.access || item.access.length === 0) return true;

  return item.access.some(permission =>
    this.permissionsService.getPermission(permission)
  );
}

      public getNavigation() {
        return this.buildNavigation(this._menu.getValue());
      }
      

}
